var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSecondaryBilling(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1668 13.3086C19.1668 16.5336 16.5585 19.1419 13.3335 19.1419L14.2084 17.6836",
    stroke: "#344054",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.83345 6.64193C0.83345 3.41693 3.44178 0.808594 6.66678 0.808594L5.79178 2.26693",
    stroke: "#344054",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3751 12.7765C12.3751 15.6181 10.0751 17.9181 7.23345 17.9181C4.39178 17.9181 2.09178 15.6181 2.09178 12.7765C2.09178 9.9348 4.39178 7.63477 7.23345 7.63477C7.36678 7.63477 7.49178 7.64312 7.63345 7.65145C10.1584 7.84312 12.1751 9.85978 12.3668 12.3848C12.3668 12.5098 12.3751 12.6348 12.3751 12.7765Z",
    stroke: "#344054",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.99998 10.502C4.99998 10.2258 5.22384 10.002 5.49998 10.002H7.49998C7.89781 10.002 8.27935 10.16 8.56065 10.4413C8.84196 10.7226 8.99998 11.1041 8.99998 11.502C8.99998 11.8998 8.84196 12.2813 8.56065 12.5626C8.27935 12.8439 7.89781 13.002 7.49998 13.002H6.49998C6.36737 13.002 6.2402 13.0546 6.14643 13.1484C6.05266 13.2422 5.99998 13.3693 5.99998 13.502V14.002H8.49998C8.77613 14.002 8.99998 14.2258 8.99998 14.502C8.99998 14.7781 8.77613 15.0019 8.49998 15.0019H5.49998C5.22384 15.0019 4.99998 14.7781 4.99998 14.502V13.502C4.99998 13.1041 5.15802 12.7226 5.43932 12.4413C5.72063 12.16 6.10216 12.002 6.49998 12.002H7.49998C7.63259 12.002 7.75977 11.9493 7.85354 11.8555C7.9473 11.7617 7.99998 11.6346 7.99998 11.502C7.99998 11.3693 7.9473 11.2422 7.85354 11.1484C7.75977 11.0546 7.63259 11.002 7.49998 11.002H5.49998C5.22384 11.002 4.99998 10.7781 4.99998 10.502Z",
    fill: "#344054"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9168 7.22564C17.9168 10.0673 15.6168 12.3673 12.7751 12.3673H12.3668C12.1751 9.84234 10.1585 7.82563 7.63345 7.63396V7.22564C7.63345 4.38397 9.93345 2.08398 12.7751 2.08398C15.6168 2.08398 17.9168 4.38397 17.9168 7.22564Z",
    stroke: "#344054",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecondaryBilling);
export default __webpack_public_path__ + "static/media/secondaryBilling.a439d9a813ff4ce52af5c118d60aab60.svg";
export { ForwardRef as ReactComponent };